
<script>
    import { selectedItem } from '../../../store/store.js';
</script>

<div class="key-value-table box">
    <h5>Underhållsplan</h5>

    <h6 style="font-weight: 500;">Finansiering</h6>
    <h6>{$selectedItem?.maintenance_plan?.funding_mechanisms ?? "Uppgifter saknas"}</h6>
    
    <h6 style="font-weight: 500;">Tidsplan</h6>
    <h6>{$selectedItem?.maintenance_plan?.maintenance_schedule ?? "Uppgifter saknas"}</h6>
</div>